import React from "react";
import "./CommonModal.scss";

interface CommonModalProps {
  isOpen: boolean; // Whether the modal is open or closed
  onClose: () => void; // Function to close the modal
  title?: string; // Modal title (optional)
  bodyContent?: React.ReactNode; // Modal body content
  footerContent?: React.ReactNode; // Optional footer content (e.g., action buttons)
  size?: "small" | "medium" | "large" | "xl"; // Size of the modal (default is 'medium')
  customClass?: string; // Custom class for styling
  overlayBackground?: string; // Background color of the overlay (default is 'rgba(0, 0, 0, 0.5)')
  closeOnOverlayClick?: boolean; // Whether the modal should close if you click on the overlay
  loading?: boolean; // Optional loading state for the modal
  loadingText?: string; // Text to show when loading is true
  showHeader?: boolean; // Whether to display the header (default is true)
  showCloseIcon?: boolean; // Whether to show the close icon (default is true)
}

const CommonModal: React.FC<CommonModalProps> = ({
  isOpen,
  onClose,
  title,
  bodyContent,
  footerContent,
  size = "medium",
  customClass = "",
  overlayBackground = "rgba(0, 0, 0, 0.8)",
  closeOnOverlayClick = false,
  loading = false,
  loadingText = "Loading...",
  showHeader = true,
  showCloseIcon = false,
}: CommonModalProps) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (closeOnOverlayClick) {
      onClose();
    }
  };

  return (
    <div
      className="common-modal"
      onClick={handleOverlayClick}
      style={{ background: overlayBackground }}>
      <div
        className={`modal-container ${size} ${customClass}`}
        onClick={(e) => e.stopPropagation()}>
        {showHeader && (
          <div className="modal-header">
            {title && <h2>{title}</h2>}
          </div>
        )}
        {showCloseIcon && (
          <button className="modal-close gradient-bg vertical-center" onClick={onClose}>
            ×
          </button>
        )}

        <div className="modal-body">
          {loading ? (
            <div className="modal-loading">
              <div className="loading-spinner"></div>
              <span>{loadingText}</span>
            </div>
          ) : (
            bodyContent
          )}
        </div>

        {footerContent && <div className="modal-footer">{footerContent}</div>}
      </div>
    </div>
  );
};

export default CommonModal;
